import React, { useContext, useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './GroomerTasks.css';
import { StateContext } from '../../../../../StateProvider';

import appointmentIcon from '../../../../../../assets/Console/Landing/appointmentIcon.png';
import guideIcon from '../../../../../../assets/Console/Landing/guideIcon.png'
import petIcon from '../../../../../../assets/Console/Landing/petIcon.png'
import eventIcon from '../../../../../../assets/Console/Landing/eventIcon.png'
import incidentIcon from '../../../../../../assets/Console/Landing/incidentIcon.png'
import supportIcon from '../../../../../../assets/Console/Landing/supportIcon.png';

import arrowIcon from '../../../../../../assets/Landing/arrowIcon.png';
import impactIcon from '../../../../../../assets/Landing/impactIcon.png';

import Footer from '../../../../../Footer';
import AnnouncementsFeed from '../../../Utils/AnnouncementsFeed';

function GroomerTasks() {
    const { loggedIn, role, financialSummary } = useContext(StateContext);
    const navigate = useNavigate();
    const [totalAnimalsHelped, setTotalAnimalsHelped] = useState(0);

    useEffect(() => {
        if (financialSummary && financialSummary.totalRevenue) {
            setTotalAnimalsHelped(calculateAnimalsHelped(financialSummary.totalRevenue));
        }
    }, [financialSummary]);

    const calculateAnimalsHelped = (totalRevenue, supportPerAnimal = 20) => {
        const allocatedAmount = totalRevenue * 0.10; // 10% of totalRevenue allocated for animal support
        return Math.floor(allocatedAmount / supportPerAnimal); // Calculate animals helped
    };

    const handleMenuButtonClicked = (page) => {
        navigate(`${page}`);
        window.scrollTo(0, 0);
    }

    const handleImpactClicked = (event) => {
        if (!loggedIn) {
          event.preventDefault(); // Prevent default <Link> navigation
          navigate('/login'); // Redirect to login page
        }
    };

    return (
        <>
            <div className="store-container">
                <h4 className='console-header'>Grooming Task Board</h4>
                <h4 className='console-message'>✨ Where safety meets style — every groom is a gentle transformation. ✨</h4>
                <div className="container store-menu-container">
                    <div className="row">
                        <div className="col store-menu-button-container">
                        <div className='store-button-image-container'>
                            <img className="store-menu-button-image" src={appointmentIcon} alt="Appointments Icon" onClick={() => handleMenuButtonClicked('/console/tasks/groomer-appointments')} />
                        </div>
                        <p className="store-menu-button-title">Appointments</p>
                        </div>
                        <div className="col store-menu-button-container">
                        <div className='store-button-image-container'>
                            <img className="store-menu-button-image" src={petIcon} alt="Clients Icon" onClick={() => handleMenuButtonClicked('/console/pets')} />
                        </div>
                        <p className="store-menu-button-title">Clients</p>
                        </div>
                        <div className="col store-menu-button-container">
                        <div className='store-button-image-container'>
                            <img className="store-menu-button-image" src={guideIcon} alt="Grooming Icon" onClick={() => handleMenuButtonClicked('/console/guides')} />
                        </div>
                        <p className="store-menu-button-title">SOP & Guides</p>
                        </div>
                    </div>
                    <div className='row'>
                        <div className="col store-menu-button-container">
                        <div className='store-button-image-container'>
                            <img className="store-menu-button-image" src={incidentIcon} alt="Homes Icon" onClick={() => handleMenuButtonClicked('incident-log')} />
                        </div>
                        <p className="store-menu-button-title">Incident Log</p>
                        </div>
                        <div className="col store-menu-button-container">
                        <div className='store-button-image-container'>
                            <img className="store-menu-button-image" src={eventIcon} alt="Apparels Icon" onClick={() => handleMenuButtonClicked('/console/events')} />
                        </div>
                        <p className="store-menu-button-title">Events</p>
                        </div>
                        <div className="col store-menu-button-container">
                        <div className='store-button-image-container'>
                            <img className="store-menu-button-image" src={supportIcon} alt="Health & Wellness Icon" onClick={() => handleMenuButtonClicked('/console/support')} />
                        </div>
                        <p className="store-menu-button-title">Help & Support</p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Daily Shop Brief */}
            <div className="staff-section-wrapper">
                <div className="staff-section-title">
                    <span>📊</span> Grooming Daily Brief
                </div>
                <div className="staff-section-grid">
                    <div className="brief-card">Total: <strong>37</strong></div>
                    <div className="brief-card">Nails: <strong>12</strong></div>
                    <div className="brief-card">Bath: <strong>18</strong></div>
                    <div className="brief-card">Grooming: <strong>4</strong></div>
                    <div className="brief-card">Teeth: <strong>3</strong></div>
                    <div className="brief-card">Incidents: <strong>0</strong></div>
                </div>
            </div>

            <AnnouncementsFeed />

            <hr className='deals-breakline'/>

            <div className='container'>
                <Link to="/store/deals/impact" className="impact-highlight" onClick={handleImpactClicked}>
                    <div className="impact-highlight-card">
                        <div className='impact-highlight-card-items'>
                            <h3 className='impact-highlight-number'>{totalAnimalsHelped}</h3>
                            <h3 className='impact-highlight-paragraph'>Animals helped. Your support enables us to contribute to animal rescue and care.</h3>
                            <div className='impact-highlight-action'>
                            <h3 className='impact-highlight-button-title'>SEE OUR IMPACT</h3>
                            <img src={arrowIcon} className='impact-highlight-button'></img>
                        </div>
                        </div>
                        <div className="impact-highlight-card-items">
                            <img className='impact-highlight-icon' src={impactIcon}></img>
                        </div>
                    </div>
                </Link>
            </div>

            <Footer />
        </>
    );
}

export default GroomerTasks;
